import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { AUTH_DEBUG_ENABLED, logAuthRouteChange } from '../../auth/authLifecycleDebug';

/**
 * Dev-only: logs every React Router location change app-wide.
 */
const AuthRouteProbe = () => {
  const location = useLocation();
  const prevRef = useRef(location.pathname);

  useEffect(() => {
    if (!AUTH_DEBUG_ENABLED) return;
    if (prevRef.current !== location.pathname) {
      logAuthRouteChange(prevRef.current, location.pathname, 'App router');
      prevRef.current = location.pathname;
    }
  }, [location.pathname, location.search, location.key]);

  return null;
};

export default AuthRouteProbe;
